import AES from 'crypto-js/aes';
import enc from 'crypto-js/enc-utf8';
import { decode as decodeBase64arraybuffer } from 'base64-arraybuffer';
import { message } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import { getAccessToken } from './users';
import { ENCRYPTION_KEY, SERVER_URL } from './constants';
import { downloadTermsAndConditions, extPost } from '../dataSource/requests';
import { SessionExpiredException } from './errors';

const REST_SERVER = SERVER_URL?.replace('/graphql', '');

export function encrypty(value: string): string {
  return AES.encrypt(value, ENCRYPTION_KEY).toString();
}

export function decrypty(value: string): string | null {
  if (value) {
    return AES.decrypt(value, ENCRYPTION_KEY).toString(enc);
  }
  return null;
}

const uploadImage = async (image:any): Promise<string | null> => {
  const blob = new Blob([image.originFileObj], { type: 'application/jpeg' });
  const response = await extPost({
    url: `${REST_SERVER}/1/uploadImageToS3`,

    headers: {
      Authorization: getAccessToken() || '',
      'Content-Type': 'application/jpeg',
    },

    params: blob,
  });

  if (response.error) {
    message.error('Não foi possível enviar a imagem. Tente novamente');
    return null;
  }
  return response.text;
};

export const uploadImageAndGetLink = async (fileList:any): Promise<any> => {
  let imgUrl;
  if (fileList[0].url && fileList[0].url !== '') {
    imgUrl = fileList[0].url;
  } else {
    imgUrl = await uploadImage(fileList[0]);
  }
  return imgUrl;
};

export const convertBase64ToArrayBuffer = async (image:any): Promise<object> => {
  const type = image[0].type.replace('image/', '');

  const imageURL = image[0].thumbUrl
    .replace(`data:image/${type};base64,`, '')
    .replace('data:image/jpg;base64,', '')
    .replace('data:image/jpeg;base64,', '')
    .replace('data:image/png;base64,', '');

  const arrayBuffer = decodeBase64arraybuffer(imageURL);

  const int8array = new Int8Array(arrayBuffer);

  return Object.values(int8array);
};

export const objectIsEmpty = (object: object): boolean => {
  if (Object.keys(object).length) {
    return false;
  }
  return true;
};

export const isEmpty = (value: any): boolean => (value === null || value === undefined || value === '');

export const downloadArchive = (buffer:any, type: string, fileName: string): void => {
  const blob = new Blob([buffer], { type });
  const link = document.createElement('a');

  link.href = window.URL.createObjectURL(blob);
  link.style.visibility = 'hidden';
  link.download = fileName;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
};

export const downloadPDF = (file: UploadFile<any>): void => {
  if (file.id) {
    downloadTermsAndConditions()
      .then((response) => {
        downloadArchive(response, 'application/pdf', file.name);
      }).catch((err) => {
        if (!(err instanceof SessionExpiredException)) {
          message.error('Erro ao fazer download do arquivo');
        }
      });
  } else {
    downloadArchive(file.originFileObj, 'application/pdf', file.name);
  }
};

export const downloadFile = (buffer:any, fileName: string): void => {
  const blob = new Blob([buffer]);
  const link = document.createElement('a');

  link.href = window.URL.createObjectURL(blob);
  link.style.visibility = 'hidden';
  link.download = fileName;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
};

export const downloadPdf = (pdf:string, nameFile: string):void => {
  const linkSource = `data:application/pdf;base64,${pdf}`;
  const downloadLink = document.createElement('a');

  downloadLink.href = linkSource;
  downloadLink.download = nameFile;
  downloadLink.click();
};

export const downloadXml = (xml:string, nameFile: string):void => {
  const linkSource = `data:application/xml;base64,${xml}`;
  const downloadLink = document.createElement('a');

  downloadLink.href = linkSource;
  downloadLink.download = nameFile;
  downloadLink.click();
};
